module.exports = "/_next/static/images/envelope-monotone-d856d9f65ef117b6e28a0eed38edd404.svg";